import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Receipt,
  Users,
  Lightbulb,
  Banknote,
  Phone,
  Settings,
  LogOut,
} from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const navItems = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/expenses', icon: Receipt, label: 'Gastos' },
  { to: '/tandas', icon: Users, label: 'Tandas' },
  { to: '/services', icon: Lightbulb, label: 'Servicios' },
  { to: '/loans', icon: Banknote, label: 'Préstamos' },
  { to: '/calls', icon: Phone, label: 'Llamadas' },
  { to: '/settings', icon: Settings, label: 'Config' },
];

export function Sidebar() {
  const { logout } = useAuth();

  return (
    <nav className="fixed left-0 top-0 h-screen w-[70px] bg-dark-card flex flex-col items-center py-4 z-50 border-r border-dark-border">
      {/* Logo */}
      <div className="text-3xl mb-6">💰</div>

      {/* Navigation */}
      <div className="flex-1 flex flex-col gap-2">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `w-12 h-12 rounded-xl flex items-center justify-center transition-all ${
                isActive
                  ? 'bg-dark-border text-primary-500'
                  : 'text-gray-500 hover:bg-dark-border hover:text-primary-500'
              }`
            }
            title={item.label}
          >
            <item.icon size={22} />
          </NavLink>
        ))}
      </div>

      {/* Logout */}
      <button
        onClick={logout}
        className="w-12 h-12 rounded-xl flex items-center justify-center text-gray-500 hover:bg-red-500/20 hover:text-red-400 transition-all"
        title="Cerrar Sesión"
      >
        <LogOut size={22} />
      </button>
    </nav>
  );
}
